import { all, fork } from "redux-saga/effects";
import { watchAuthRequests } from "./AuthSaga";
import { watchSearchRequests } from "./SearchSaga";
import { watchFeedRequests } from "./FeedSaga";
import { watchCommentRequests } from "./CommentSaga";
import { watchNotificationsChanges } from "./NotificationSaga";
import { watchFollowRequests } from "./FollowSaga";
import watchUiChanges from "./UiSaga";
import { watchCollectionRequests } from "./CollectionSaga";
// Bootstrap sagas
export default function* root(dispatch) {
  yield all([
    fork(watchSearchRequests),
    fork(watchFeedRequests),
    fork(watchAuthRequests),
    fork(watchCommentRequests),
    fork(watchNotificationsChanges, dispatch),
    fork(watchFollowRequests),
    fork(watchCollectionRequests),
    fork(watchUiChanges),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/client.js